<span>
  {{data}}
</span>
